import { Text } from 'ol/style';
import VectorSource from 'ol/source/Vector';
import { StyleFunction } from './getStyle';

export function areLabelsActive(
  styleFunction: StyleFunction | undefined,
  source: VectorSource,
): boolean {
  let labelsAreActive = false;

  if (styleFunction && source.getFeatures().length > 0) {
    // Apply the style function to a sample feature to see if text is set
    const sampleFeature = source.getFeatures()[0]; // Assuming at least one feature exists
    const style = styleFunction(sampleFeature, 1); // Second argument is the view resolution

    if (Array.isArray(style)) {
      labelsAreActive = style.some((s) => {
        const text: Text | null = s.getText();
        return text !== null && text.getText() !== '';
      });
    } else if (style) {
      const text: Text | null = style.getText();
      labelsAreActive = text !== null && text.getText() !== '';
    }
  }

  return labelsAreActive;
}
